export const measureParser = (measure) => (measure.toString().includes('px') || measure.toString().includes('%') ? measure : `${measure}px`);

export const calcItemsPerPageData = (total) => {
  const array = [20, 50, 100, 200, 400];
  const newArray = [];
  array.forEach((item) => {
    if (item <= total) {
      newArray.push(item);
    } else if (item - total <= total) newArray.push(item);
  });
  return newArray;
};

export const clickOutside = (ref, onClickCb) => {
  if (!ref?.current) return;
  const handleClickOutside = (e) => {
    if (ref?.current && !ref.current.contains(e.target)) {
      onClickCb(e);
    }
  };
  // // document.addEventListener('mousedown', handleClickOutside);
  // // return () => {
  // //   document.removeEventListener('mousedown', handleClickOutside);
  // // };
};
